import React from 'react';
import { Chip } from '@mui/material';
import { useTranslation } from '../../../app/LanguageContext';

const STATUS_CONFIG = {
  PREPARATION: { color: 'default', labelKey: 'consignment.status_preparation' },
  ACTIVE: { color: 'success', labelKey: 'consignment.status_active' },
  RENEWAL_PENDING: { color: 'warning', labelKey: 'consignment.status_renewal_pending' },
  RENEWED: { color: 'info', labelKey: 'consignment.status_renewed' },
  CLOSED: { color: 'secondary', labelKey: 'consignment.status_closed' },
  CANCELLED: { color: 'error', labelKey: 'consignment.status_cancelled' },
};

export default function ConsignmentStatusChip({ status, size = 'small' }) {
  const { translate } = useTranslation();
  const cfg = STATUS_CONFIG[status] || STATUS_CONFIG.PREPARATION;
  return (
    <Chip
      label={translate(cfg.labelKey)}
      color={cfg.color}
      size={size}
      variant="outlined"
    />
  );
}
